export default __webpack_public_path__ + "static/media/play.5a12e1ea.svg";